import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const PaymentContractor = () => {
  return (
    <SettingsMetaData propertyName={"Payment_Terms_Contractor"} viewPropertyName={"Payment Terms"} />
  );
};
export default PaymentContractor;